module.exports = __webpack_public_path__ + "static/media/logo.fd4acf8f.png";